<template>
  <va-popover color="white" :hover-over-timeout="1600" v-bind="$attrs">
    <slot />
  </va-popover>
</template>
